import React from 'react';
import { pure } from 'recompose';
import Link from 'ha/ui/next/Link';
import { UniMarker } from './Types';

interface Props {
  university: UniMarker;
}

export const PartnerPreview: React.FC<Props> = ({ university }) => (
  <div className="small text-center p-a-1">
    {university.url ? (
      <Link to={university.url} className="color-attention">
        {university.name}
      </Link>
    ) : (
      university.name
    )}
  </div>
);

export default pure(PartnerPreview);
